import { render, staticRenderFns } from "./CoozzyCloseIcon.vue?vue&type=template&id=f25b81de&scoped=true"
import script from "./CoozzyCloseIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyCloseIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyCloseIcon.vue?vue&type=style&index=0&id=f25b81de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25b81de",
  null
  
)

export default component.exports